export const threatCatalogKeys = {
  all: ["threatCatalog"] as const,
  catalog: (threatCatalogId: string) => [...threatCatalogKeys.all, threatCatalogId] as const,
  name: (threatCatalogId: string) => [...threatCatalogKeys.all, "name", threatCatalogId] as const,
  import: (threatCatalogId: string, fileContents: any) =>
    [...threatCatalogKeys.all, "upload", threatCatalogId, fileContents] as const,
};
